export default __webpack_public_path__ + "static/media/logo-white.4e1ed9e6.png";